module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("2")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("The Idolization of Virginity")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("A")]), _vm._v("my Deneson was given her first purity ring when she was thirteen years old. “Accepting it meant I promised to stay a virgin until my wedding night—to keep my mind innocent, my body untouched, my soul blameless—so that I could one day present my husband with the ultimate gift,” she said."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Deneson viewed her ring as a visible sign of her countercultural commitment to remain a virgin until marriage. When the heart-shaped stone fell out of the ring one day during basketball practice, she panicked, concerned that a damaged purity ring might foreshadow some threat to her sexual purity.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Virginity as Worth")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If purity culture were a throne, virginity would be the queen sitting on it. It’s presented not only as a God-honoring pursuit but as a determinant of personal value. Roses are passed around rooms full of nervous teenagers, then held up, crumpled and bruised, with fewer petals, as an example of what happens to those who give their virginity away. Paper is ripped in half. “The pastor explained that we could never get our purity back—it was like water that had been spit in or gum that had been chewed,” Rebecca Lemke writes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-021",
      "id": "ap_ntf-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" This idea was especially emphasized to women. Sara Moslener, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("purity culture historian and author of "), _c('i', [_vm._v("Virgin Nation: Sexual Purity and American Adolescence")]), _vm._v(", notes how James Dobson painted a picture of “female sexuality as a commodity that reach[es] the height of its value on the wedding day.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-022",
      "id": "ap_ntf-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" A woman’s worth rests not in her soul but between her legs, as if virginity were some remnant of pre-fall righteousness, untainted by Adam and Eve’s sin, which a woman can protect if she is hypervigilant enough.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When virginity is painted this way, as the greatest gift one can give their spouse, those who lose their virginity before marriage are seen as having less to offer. Their only choice is to try to gather the fallen petals of their personal worth into the shape of a bouquet as best they can. The concept of “second” or “renewed” virginity is a common theme in purity rhetoric, but the trauma of these visual metaphors speaks louder than any footnote about second chances. One might be able to seek forgiveness and recommit to chastity but “it’s difficult to repair a broken china cup.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I love what Debra Hirsch says in her book "), _c('i', [_vm._v("Redeeming Sex")]), _vm._v(": “Every human being on the planet is sexually broken . . . all of us are on a journey toward wholeness; not one of us is excluded.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Whether someone is a virgin, has been raped, or has “slept around,” we are all broken from the fall. We all need Jesus. And thankfully our value as image bearers is not dependent on our sexual past. In his recent book "), _c('i', [_vm._v("The Dignity Revolution")]), _vm._v(", Daniel Darling writes: “You were valuable before you did anything.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" And I would add, you are just as valuable, even if you have done many things that fall short of the righteousness of God. Jesus has taken those failings and abuses on himself, crucifying them on the cross.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Virginity as Purity")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I am thankful that in this sex-saturated world my parents told me where sex belongs—in marriage—and my church "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("reaffirmed it. I am glad that I had sex for the first time on my wedding night. If I ever have children, I will teach them what the Bible says about sex, that it was created by God to be an act of unifying self-giving within the marriage covenant between one man and one woman. I will teach them that, in marriage, sex is a God-honoring good, but that extramarital sex is a sin against a holy and loving Father. But I will not tell them that virginity makes them pure.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I may have been a virgin when I got married, but I was already a sexual sinner. As a young believer, my virgin status kept me from recognizing this. It was so easy to justify my lust and selfishness by telling myself: “You have never even kissed a boy.” I knew plenty of others who had not only kissed their boyfriends but had done a lot more. My childhood best friend was pregnant by the age of fifteen. Surely I was sexually pure by comparison.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But I was not. Jesus’ words from the Sermon on the Mount are chilling in their inclusivity: anyone who looks at another person with lust has committed adultery with them in their heart. I may have been a virgin when I got married, but I was also an adulterer. Virginity means only that an individual has never decided to or been forced to have sexual intercourse with another person. It is not a badge of holiness, a sign of sexual purity, or a ticket to heaven.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The term “technical virginity” exists because of how inventive we are when it comes to finding sexual activities outside of sexual intercourse. While I have known Christians who refuse to even hold hands before marriage, others, pointing to virginity as the definition of sexual purity, are willing to engage in anything from mutual masturbation to oral sex, avoiding "), _c('i', [_vm._v("only")]), _vm._v(" the act of genital penetration. Virginity as purity neglects Jesus’ call for the pursuit of whole-person "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("purity, which includes not only the hymen but our whole body, mind, and heart.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To understand purity culture’s emphasis on virginity, we must recognize that the Bible has not been the only influence behind the movement. Much of modern purity culture has been shaped by our nationwide reaction to the threat of STDs and teenage pregnancy, brought on by the sexual revolution of the 1960s to the 1980s. Linda Kay Klein, author of "), _c('i', [_vm._v("Pure: Inside the Evangelical Movement That Shamed a Generation of Young Women and How I Broke Free")]), _vm._v(", points out: “Americans were scared. AIDS was killing people by the thousands, there were growing concerns about other sexually transmitted infections. . . . And many conservatives believed the return to traditional values, including chastity, was the only solution.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One of the greatest tensions in the modern Christian purity movement has been federally funded abstinence education. Groups like Silver Ring Thing (founded by Christians) recognized that their message could go much further if they accepted government help. While Silver Ring Thing accepted the funds, founder Denny Pattyn was “disgusted by the government’s insistence that his abstinence work be devoid of all religious content,” believing that true change takes place in individuals through the power of the Holy Spirit."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Still, federal funding meant that more teenagers would be exposed to abstinence as an option.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Abstinence education has been supported with federal funds under the last four presidents, and according to "), _c('i', [_vm._v("The Hill")]), _vm._v(", abstinence-only education is “making a comeback” under current president Donald Trump."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-028",
      "id": "ap_ntf-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" One question Christians need to ask is: What happens to the message of sexual purity when it is taught apart from Christ? Whether one is for or against government-funded abstinence education, it is a question worth pondering.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Virginity as Identity")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Appealing to modern American teenagers meant emphasizing rebellion and identity. Strategies for attracting teenagers to chastity had to focus more on individual benefits and consequences than the glory of God. Christine Gardner says that the abstinence events she attended were full of live concerts and personal testimonials."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-029",
      "id": "ap_ntf-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" The books I read growing up focused on how my sexual behavior would impact "), _c('i', [_vm._v("my ")]), _vm._v("life, "), _c('i', [_vm._v("my")]), _vm._v(" reputation, and "), _c('i', [_vm._v("my")]), _vm._v(" marriage.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The American shift toward individualism, with our “army of one” commercials and our idolization of the “personal journey,” seeped into evangelical culture. Growing up, the emphasis was on “me and Jesus” more than my role as a member of the body of Christ. I didn’t even become familiar with the term “common good” in regard to Christian theology until I began graduate school in my early thirties.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Modern purity teachings harnessed individualism, depicting sexual self-restraint as a choice for “self-care” and a way to ensure a future satisfying sex life within marriage."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-030",
      "id": "ap_ntf-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" And for a time, abstinence was trending. I remember celebrities such as Britney Spears and Jessica Simpson wearing purity rings. Later, young stars such as the Jonas Brothers and Miley Cyrus kept the trend going. Gardner notes that purity rhetoric essentially borrows the feminist message of “my body, my choice” in order to convince teenagers that sexual abstinence is about asserting their agency."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-031",
      "id": "ap_ntf-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" The purity movement tried to make chastity attractive by highlighting the rebellion required to say no to premarital sex in a culture so used to saying yes.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The emphasis on personal choice included a public element. This is where purity rings, necklaces, and events like father/daughter purity balls came into vogue. One woman I interviewed said her dad brought home a ring from Italy for her to wear, to symbolize her commitment to chastity. The "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("purity ring given by one’s parents or purchased at abstinence events such as Silver Ring Thing even became a part of some wedding ceremonies.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another woman, Nicole, told me that she viewed her virginity as “a badge of honor.” She wore a purity ring until the day she got married and on her wedding day, “my dad took the ring off, then handed it to my groom.” “I cringe to think of that now,” she added.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“What about that memory makes you cringe?” I asked. She responded:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_vm._v("My motivations were off. My husband and I met in high school and dated for several years before we got married. I think part of me wanted to protect my reputation. See, everybody? We really did wait. I also think so much of my identity at the time was wrapped up in being the good Christian girl. The whole ceremony reminds me of the Pharisees. I feel like I was saying, “Look at me—I’m so pure, I’m so holy,” when my heart was full of pride and fear.")]), _c('p', {
    staticClass: "txt_courant_justif last retrait_autre"
  }, [_vm._v("Also, I no longer see purity as a gift one spouse gives to another. God has made me pure through Christ, and he alone keeps me pure. Purity, then, is mainly about me and God, not me and my husband. Sexual purity is the natural overflow of humbly placing myself under God’s authority, acknowledging my own sinfulness, and depending on Christ to help me walk in holiness. When I am living in purity, my husband and my marriage definitely benefit. But that is God’s grace, not my own doing.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Nicole describes exactly what can go wrong when sexual purity is motivated by personal identity and the approval of others more than the glory of God. While she made it to the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("altar a virgin, her story still holds regret due to wrong motivations for right actions.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another woman, Stephanie, told me: “I went to the purity class, I had the ring, but inside I was torn apart by my hidden sin.” While highlighting individualism might be a brilliant rhetorical tactic, these motivators eventually crumble when they come up against other equally self-centered desires. Pursuing sexual purity for the sake of one’s identity and reputation is a foundation built on shifting sand.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Virginity-as-identity has caused some to experience unnecessary guilt and confusion when they finally experience sex in marriage. If you’ve listened to people talk about growing up in purity culture for any length of time, you’ve probably heard the “light switch” analogy—the expectation that one can transition from being completely virginal to sexually uninhibited on their honeymoon, as quickly as flipping a light switch. But many Christians have struggled to find the light switch, especially those who saw virginity as part of their identity.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The writers of "), _c('i', [_vm._v("Jane the Virgin, ")]), _vm._v("a television dramedy series, captured this tension in the episode where Jane, the main character, finally loses her virginity. Having grown up Catholic, she chose to wait to have sex until marriage. When she and her husband finally consummate their union, instead of feeling joy, Jane feels disconnected from herself. She wonders who she is now that she is not a virgin."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-032",
      "id": "ap_ntf-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For some people, sex within marriage, which is meant to unite a couple and bring them joy and pleasure, is accompanied by shame. This is especially common for Christian women. I talked to a young bride recently who confessed that, growing up in the church, the only thing she heard about sex was “don’t do it.” Now, two years into marriage and after the birth of their first child, she told me: “I still struggle "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("with feeling dirty, slutty, and sinful when I’m intimate with my husband.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Because female sexuality is often downplayed in purity culture, there’s an extra layer of guilt for Christian women, not only about committing sexual sin but about their identity as sexual beings. This shame can lead women to demonize their God-given sexuality and can also, in turn, make the “switch” from virgin to sexually active in marriage a time of guilt rather than joy. Linda Kay Klein notes how confusing this message can be for women:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The purity movement teaches us that a “pure” woman comes to her husband an untouched virgin who has hardly (if ever) thought about sex before. And then, naturally and beautifully, the woman’s new husband introduces his wife to sexuality for the first time and years of pent-up sexual energy which she was not even aware of come pouring out of her, allowing her to meet her new husband’s every sexual want, which is also her every want, and together they live happily ever after. Both the repressed sexuality of the virgin and the fully surrendered sexuality of the wife are requirements of purity culture—one being fabled to lead to the other."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-033",
      "id": "ap_ntf-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Returning to the example from "), _c('i', [_vm._v("Jane the Virgin")]), _vm._v(", it is interesting that Jane feels the pressure to fake an orgasm during her first experience with sex. When her husband finds out that she lied, he is confused, but the viewer sees the situation very clearly: sex has been built up in Jane’s mind for years, and she wants her first experience to be perfect, especially for her husband. Jane’s fictional experience illustrates a truth I heard repeatedly from those I interviewed: the transition from virgin to sexually active in marriage is nothing like turning on a light switch.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Sexual Self-Control Is a Lifelong Pursuit")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Purity culture’s obsession with virginity also obscures the fact that our call to sexual purity is lifelong. Adolescents are encouraged that if they just hold out for a little while they will soon get married and be able to unleash all their sexual energy on another person. Not only does this dehumanize image bearers of God by painting them as nothing more than sexual outlets, it depicts the pursuit of purity as a season in life rather than a lifelong calling. Books and resources about sexual purity focus mainly on young singles rather than addressing Christians in all circumstances.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A friend of mine, Laura, shared an interesting story that highlights our need for a lifelong commitment to purity—and it also gave me a new appreciation for purity rings. She said that she was given her ring at age fourteen and she wore it up until the day she got married. On her wedding night, she gave it to her husband. “It was beautiful, and I was so thankful that I’d waited,” Laura said. But a few months later, she was horrified to discover that she felt attracted to someone else: “I guess I’d naively thought that marriage (and great sex) would resolve the whole purity problem.” She decided to find her purity ring, which was nestled in her husband’s sock drawer, and put it back on her finger again, as a reminder to herself and to her husband that she was still committed to sexual purity. “Because purity isn’t an ‘until marriage’ thing,” she said. “I think it’s more of an ‘until death’ sort of thing. Single, married, divorced, same-sex attracted, asexual, whatever. It’s a dangerous thing when married sex becomes the ‘finish line’ for sexual purity.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This can feel overwhelming. Maybe that’s one reason Scripture speaks so often about our need for endurance. Maybe it’s also why purity rhetoric places such an emphasis on waiting "), _c('i', [_vm._v("until ")]), _vm._v("marriage, because the pursuit of purity feels "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("more achievable when there is an end date. But the Bible makes no such promises. We are called to pursue purity until the day we die or Jesus returns, whichever comes first.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But does the pursuit of sexual purity always include virginity? Clearly, there are scenarios where it doesn’t—for instance, with someone who has been raped, or someone who was previously married, or someone who is currently married, or someone who has sinned sexually in the past. For many of us, the pursuit of sexual purity "), _c('i', [_vm._v("will")]), _vm._v(" include virginity. It did for me until I was twenty-four. But then I got married, and sexual purity meant continuing to try to view people as brothers and sisters in all purity while engaging in the deep and exclusive act of sex with one person, my husband.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After five years of marriage, however, my husband chose to divorce me. At age thirty, I found myself single again. Only this time, I was no longer a virgin. I desperately wanted to honor God by seeking sexual purity, but finding my identity and empowerment in virginity was not possible this time around. I knew that the dating pool would lessen for me now that I was no longer a virgin and carried the baggage of divorce. Not only that, but love had been awakened, as Song of Songs 8:4 talks about, and there was no way to tell it to go back to sleep. My call as a divorced, nonvirgin in her thirties was the same as when I was fourteen or when I was twenty: love God and others with all my heart, mind, body, soul, and strength.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Source of All Purity")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Deneson points out that “for three decades, virginity pledges were tallied by the Government Accountability Office as proof of efficacy. Success was loosely measured in ring receipts and course completions, irrespective of the person’s actual behavior.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-034",
      "id": "ap_ntf-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" And in the same way wearing a purity ring does not guarantee virginity, virginity doesn’t guarantee purity.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("Virginity is an idol in purity culture that must be dethroned. Dan B. Allender, coauthor of "), _c('i', [_vm._v("God Loves Sex")]), _vm._v(", says that he has “worked with countless men and women who were virgins at marriage, escaped the perversion of pornography, and never kissed their spouse until their wedding day—yet still warred with dark desires or the absence of desire at various periods in their marriage.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-035",
      "id": "ap_ntf-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Virgins or not, Christians are real people who wrestle with sexual temptation. Instead of fixating on virginity, our goal as Christians must be God’s glory in our sexual brokenness. The elevation of virginity and the promised reward of great married sex for the chaste not only creates false expectations but makes the pursuit of sexual purity all about personal fulfillment.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Christine Gardner put it best when she said that the solution for evangelicals is not “to value virginity less but to value God more.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-036",
      "id": "ap_ntf-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Too often our elevation of virginity neglects the true source of our purity. The idea that we need to offer nonvirgins some sort of symbolic “second virginity” reinforces our misunderstanding of where purity comes from. We have been made new, washed clean “with the precious blood of Christ, a lamb without blemish or defect” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1+Peter+1%3A19&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("1 Peter 1:19")]), _vm._v("). Virginity does not provide our purity. Jesus does.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Both sexual sin and abuse come with pain and scars. There are things you’ll have to work through, especially if there has been trauma. But you are in no way a less valuable potential spouse, person, or Christian because of what you’ve done or what’s been done to you sexually. Virginity is not required to have a God-honoring life or a healthy marriage. The best gift you can give yourself, your community, or a future spouse is a life surrendered to Christ.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I have heard too many teenagers say: “Well, I’ve already gone there once. I might as well do it again.” Paul must have heard statements like this too because in Romans 6:1 he asks: “What shall we say, then? Shall we go on sinning so that grace "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("may increase?” If we elevate virginity to the point where some feel permanently defeated, then we have ceased to help our brothers and sisters pursue sexual purity.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Not one of us is a crumpled rose, a used car, or an incomplete person. You are a precious image bearer of God. Your purity has already been won for you in Christ, and your dedication to pursuing sexual purity is not defined by your virginity but by your surrender to Christ and dependence on the Holy Spirit "), _c('i', [_vm._v("today. ")]), _vm._v("Today is a new day to pursue sexual purity out of love for the God who rescued you and brought you safely to himself in Christ. As Lauren Winner, author of "), _c('i', [_vm._v("Real Sex: The Naked Truth About Chastity")]), _vm._v(", says, when it comes to purity, the most important question to ask is not, what have I done but, what am I doing now?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-037",
      "id": "ap_ntf-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Discussion Questions")]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Did you experience any purity demonstrations, like passing a rose around the room, when you were young? If so, how did they affect you? What do you think of such metaphors now?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Is virginity the best gift a person can give their spouse? Why or why not?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" What are your thoughts on government-funded abstinence education?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("4")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Is there a place for purity rings, necklaces, and pledge cards?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("5")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" How does sexual sin affect marriage? How can we talk about sexual sin in a healthy, biblical way?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" How would you define sexual purity?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" If you ever have children, how will you talk about virginity with your child?")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("ACTIVITY")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Take some time to finish these sentences individually. If you’re having trouble answering them for yourself, try answering them based on what you would want your child to be able to say about themselves. After everyone is finished, go around and share some of your responses.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I have value because:____________________________________")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When God sees me, he sees:_______________________________")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My sins are:___________________________________________")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My commitment to sexual purity today looks like:_________________")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 75
// module chunks = 0